module.exports = __webpack_public_path__ + "img/logo-mini.5c9660ac.png";